import state from './user.state'
import mutations from './user.mutations'
import actions from './user.actions'

export default {
  namespaced: true,
  state,
  mutations,
  actions
}